import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';

class UsModalStore {
  @observable isOpen;
  @observable closeCallback = noop;

  @observable modalType = 1;

  constructor(options = {}) {
    // super();
    Object.assign(this, options);
  }
  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.onClose();
  };

  use() {}
}

export default UsModalStore;
